"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplierPrice = void 0;
const typeorm_1 = require("typeorm");
const ServiceStep_1 = require("../../service/entity/ServiceStep");
// eslint-disable-next-line import/no-cycle
const Supplier_1 = require("./Supplier");
const CircularReference_1 = require("../../serialization/CircularReference");
const PriceConfiguration_1 = require("../../prices/entity/PriceConfiguration");
let SupplierPrice = class SupplierPrice extends PriceConfiguration_1.PriceConfiguration {
    constructor(init) {
        super();
        if (init) {
            Object.assign(this, init);
        }
    }
};
exports.SupplierPrice = SupplierPrice;
__decorate([
    (0, typeorm_1.ManyToOne)(() => Supplier_1.Supplier, (s) => s.prices),
    (0, CircularReference_1.CircularRef)(),
    __metadata("design:type", Supplier_1.Supplier)
], SupplierPrice.prototype, "supplier", void 0);
__decorate([
    (0, typeorm_1.RelationId)((sp) => sp.supplier),
    __metadata("design:type", String)
], SupplierPrice.prototype, "supplierId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => ServiceStep_1.ServiceStep, { nullable: true }),
    __metadata("design:type", ServiceStep_1.ServiceStep)
], SupplierPrice.prototype, "serviceStep", void 0);
__decorate([
    (0, typeorm_1.RelationId)((sp) => sp.serviceStep),
    __metadata("design:type", String)
], SupplierPrice.prototype, "serviceStepId", void 0);
exports.SupplierPrice = SupplierPrice = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], SupplierPrice);
